import React from 'react';

const Footer = () => {
    return (
        <>
            <footer>
                <p>Created With ❤️ By &copy; Aryan Garg @2021</p>
            </footer>
        </>
    );
}

export default Footer;
